import { useFormik } from "formik";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { API } from "../../api/api";
import constants from "../../utils/contants";

const AddDriverModal = (props) => {

    useEffect(() => {
    }, []);

    const validationSchema = Yup.object().shape({
        firstname: Yup.string().required("Please Enter Firstname"),
        lastname: Yup.string().required("Please Enter Lastname"),
        email: Yup.string().required("Please Enter email"),
        phone: Yup.number().required().positive().integer(),
        password: Yup.string().required("Please Enter Password"),
        gender: Yup.string().required("Please Select Gender"),
    });

    const formik = useFormik({
        initialValues: {
            firstname: "",
            lastname: "",
            email: "",
            password: "",
            phone: "",
            gender: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("values: ", values);
            API(`create-driver`, "post", '', localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    console.log("res: ", res);
                    toast.success("Driver Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                })
                .catch((error) => {
                    toast.error("Error while updating Driver Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    return (
        <div
            id="addAdviceModal"
            className="modal modal-content-scrollable"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content ">
                    <div className="modal-header primary_bg border-1 bg_blue">
                        <h5 className="modal-title">Add Driver</h5>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            id="close__button"
                        ></button>
                    </div>
                    <div className="modal-body primary_bg">
                        <div className="d-flex flex-column">
                            <label className="category_label">Firstname</label>
                            <input
                                type="text"
                                name="firstname"
                                // placeholder="Firstname"
                                className="form form-control bg-transparent add_inputs"
                                {...formik.getFieldProps("firstname")}
                            />
                            {formik.touched.firstname && formik.errors.firstname && (
                                <div className="text-danger">{formik.errors.firstname}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Lastname</label>
                            <input
                                type="text"
                                name="lastname"
                                // placeholder="Enter Advice Title"
                                className="form form-control bg-transparent add_inputs"
                                {...formik.getFieldProps("lastname")}
                            />
                            {formik.touched.lastname && formik.errors.lastname && (
                                <div className="text-danger">{formik.errors.lastname}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Email</label>
                            <input
                                type="text"
                                name="email"
                                className="form form-control bg-transparent text-black type_password"
                                // {...formik.getFieldProps("email")}
                                value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue("email", e.target.value?.trimStart())
                                }}
                            />
                            {formik.touched.email && formik.errors.email && (
                                <div className="text-danger">{formik.errors.email}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Password</label>
                            <input
                                type="text"
                                name="password"
                                // placeholder="Enter Advice Title"
                                className="form form-control bg-transparent add_inputs"
                                {...formik.getFieldProps("password")}
                            />
                            {formik.touched.password && formik.errors.password && (
                                <div className="text-danger">{formik.errors.password}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Country Code</label>
                            <select
                                type="text"
                                name="status"
                                className="form form-control bg-transparent text-black"
                                // {...formik.getFieldProps("username")}
                                defaultValue={formik.values.vehicle}
                                onChange={(e) => {
                                    formik.setFieldValue("vehicle", e.target.value)
                                }} >
                                <option value='+1'>+1</option>
                                <option value='+91'>+91</option>
                            </select>
                            {formik.touched.car_info?.car_type?.name && formik.errors.car_info?.car_type?.name && (
                                <div className="text-danger">{formik.errors.car_info?.car_type?.name}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Phone No.</label>
                            <input
                                type="text"
                                name="phone"
                                className="form form-control bg-transparent text-black"
                                // {...formik.getFieldProps("username")}
                                value={formik.values.phone}
                                onChange={(e) => {
                                    formik.setFieldValue("phone", e.target.value?.trimStart())
                                }}
                            />
                            {formik.touched.phone_no && formik.errors.phone_no && (
                                <div className="text-danger">{formik.errors.phone_no}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Gender</label>
                            <select
                                type="text"
                                name="gender"
                                className="form form-control bg-transparent text-black"
                                // {...formik.getFieldProps("username")}
                                defaultValue={formik.values.vehicle}
                                onChange={(e) => {
                                    formik.setFieldValue("gender", e.target.value)
                                }} >
                                <option value='male'>Male</option>
                                <option value='female'>Female</option>
                            </select>
                            {formik.touched.gender && formik.errors.gender && (
                                <div className="text-danger">{formik.errors.gender}</div>
                            )}
                        </div>
                        
                    </div>
                    <div className="modal-footer border-0 primary_bg">
                        <button
                            type="button"
                            className="btn btn-secondary border-0"
                            //   data-bs-dismiss="modal"
                            onClick={() => {
                                formik.resetForm();
                            }}
                        >
                            Clear
                        </button>
                        <button
                            type="button"
                            className="btn btn_orange text-white"
                            onClick={formik.handleSubmit}
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddDriverModal;
